/* eslint-disable */
export default {
  actions: {
    'Campaign': 'History_Description_Campaign_Copy',
    'AdGroup': 'History_Description_AdGroup_Copy',
    'Ad': 'History_Description_Ad_Copy',
    'Keyword': 'History_Description_Keyword_Copy',
    'AssetGroup': 'History_Description_AssetGroup_Copy'
  },
  args: {
    'Bid/Amount': 'History_Description_Arg_Copy_IncludeBids',
    'DestinationUrl': 'History_Description_Arg_Copy_IncludeDestinationURLs',
    'Status': 'History_Description_Arg_Copy_PauseAfterPasting'
  },
  idBasedSelection: {
    'Campaign': {
      'Singular': 'History_Selection_Copy_IdBased_OneCampaign',
      'Plural': 'History_Selection_Copy_IdBased_NCampaigns'
    },
    'AdGroup': {
      'Singular': 'History_Selection_Copy_IdBased_OneAdGroup',
      'Plural': 'History_Selection_Copy_IdBased_NAdGroups'
    },
    'Ad': {
      'Singular': 'History_Selection_Copy_IdBased_OneAd',
      'Plural': 'History_Selection_Copy_IdBased_NAds'
    },
    'Keyword': {
      'Singular': 'History_Selection_Copy_IdBased_OneKeyword',
      'Plural': 'History_Selection_Copy_IdBased_NKeywords'
    },
    'AssetGroup': {
      'Singular': 'History_Selection_Copy_IdBased_OneAssetGroup',
      'Plural': 'History_Selection_Copy_IdBased_NAssetGroups'
    }
  },
  filteredSelection: {
    'Campaign': 'History_Selection_Copy_Filter_Campaign',
    'AdGroup': 'History_Selection_Copy_Filter_AdGroup',
    'Ad': 'History_Selection_Copy_Filter_Ad',
    'Keyword': 'History_Selection_Copy_Filter_Keyword',
    'AssetGroup': 'History_Selection_Copy_Filter_AssetGroup'
  },
  entityProperties: {
    'AdgroupCampaignId': 'campaignId',
    'AdAdgroupId': 'adGroupId',
    'KeywordAdgroupId': 'adGroupId',
    'CampaignName': 'campaignName',
    'AdgroupName': 'adGroupName',
    'AssetgroupId': 'assetGroupId'
  }
};

